<script lang="ts" context="module">
/** クリップボードに引数の文字列をコピーする
 * @param {string} message コピーする文字列
 */
export const copyClipbord = (message:string) => {
    navigator.clipboard.writeText(message)
    .then(() => {
        console.log("Text copied to clipboard...")
    })
    .catch(err => {
        console.log('Something went wrong', err);
    })
}

/** 引数の文字列が定義済みかつ空文字列でないことを確認する
 * @param {string} text 判定する文字列
 * @returns {boolean}
 */
export const isNotTextEmpty = (text:string): boolean => {
    return text !== null && text !== undefined && text !== ''
}
</script>
